import { Text } from '@design-system/text';
import BillingActions from './components/billing-actions';
import FilterPills from '@src/features/settings/pages/billing/components/filter-pills';
import { billingTabs } from './constants';

const BillingAndSubscription = () => {
  return (
    <div className='px-8 py-6'>
      <div className='flex items-center justify-between mb-3'>
        <Text className='text-gray-800 font-medium text-lg'>
          Billing & Subscription
        </Text>
        <BillingActions />
      </div>
      <FilterPills tabs={billingTabs} />
    </div>
  );
};

export default BillingAndSubscription;
